import { UntypedFormGroup } from '@angular/forms';
import { QuestionBase } from '@jump-tech-frontend/domain';
import { I18nKeys } from '@jump-tech-frontend/app-config';

export function buildMessages(form: UntypedFormGroup, question: QuestionBase<any>, i18ns: I18nKeys) {
  const errors = form.get(question.key)?.errors;
  const pattern = errors?.['pattern']?.requiredPattern ? errors?.['pattern']?.requiredPattern : '';
  const patternErrorMessage = `${i18ns.required} : ${pattern}`;
  return { required: i18ns.required, pattern: question.errorMessage ?? patternErrorMessage };
}
